import _typeof from "@babel/runtime/helpers/typeof";
import { DIMENSION_TYPE } from '@carnica/utils/hooks';
var convertSize = function convertSize(size) {
  return typeof size === 'number' ? "".concat(size, "px") : size;
};
export var getSize = function getSize(size, dimension) {
  if (_typeof(size) === 'object') {
    if (dimension === DIMENSION_TYPE.TABLET && !size[dimension]) {
      return convertSize(size.desktop);
    }
    return convertSize(size[dimension] || 100);
  }
  return convertSize(size);
};